module.exports = __webpack_public_path__ + "img/ActorForm.04e5c936.jpg";